/** Hard cap on how many conversations a single test-metric run may evaluate. */
export const MAX_TEST_CONVERSATIONS = 100

/**
 * Resolve the effective run set from the user's selection.
 *
 * `selectedRunIds === null` means the user hasn't touched the selection, so we
 * default to every filtered sim. The result preserves `orderedIds` order and is
 * capped at MAX_TEST_CONVERSATIONS, so both the run and the checkbox UI agree on
 * which rows are in.
 */
export function resolveRunSelection(
  orderedIds: string[],
  selectedRunIds: Set<string> | null,
): { runIds: string[]; runIdSet: Set<string> } {
  const base =
    selectedRunIds === null
      ? orderedIds
      : orderedIds.filter((id) => selectedRunIds.has(id))
  const runIds = base.slice(0, MAX_TEST_CONVERSATIONS)
  return { runIds, runIdSet: new Set(runIds) }
}
